import { render } from "./hero.vue?vue&type=template&id=ec984c2c&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=ec984c2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ec984c2c"

export default script